@import 'styles/mixins';
@import 'styles/variables';

.actionForm {
  display: flex;
  align-items: center;
}
